import { Component, OnInit } from '@angular/core';
import { Globals } from '../../globals';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
//import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { CartService } from '../../services/apicart/cart.service';


@Component({
    selector: 'app-detailproduct',
    templateUrl: './detailproduct.component.html',
    styleUrls: ['./detailproduct.component.css']
})
export class DetailproductComponent implements OnInit {
    public item: any = {};
    public list = { data: [], cached: [], active: 0, limit: 3 };
    public data = [];
    public width: number;
    public cart: any = {};
    public amount: number;
    modalRef: BsModalRef;
    public parent_link;
    public link;
    public token: any = {
        getProductDetail: "api/getrowproduct",
        updateViews: "api/views",
        productcatalogry: "api/productcatalogrylimit"
    }
    public connect;
    constructor(
        // private modalService: BsModalService,
        public route: ActivatedRoute,
        public router: Router,
        private apiCart: CartService,
        public globals: Globals,
    ) {
        this.amount = (+isNaN(this.amount) || this.amount == 0) ? 1 : this.amount;
        this.width = document.body.getBoundingClientRect().width
        this.connect = this.globals.result.subscribe((res: any) => {
            switch (res.token) {

                case "getProductDetail":
                    this.item = res.data;
                    let listimages = (res.data.listimages && res.data.listimages.length > 5) ? JSON.parse(res.data.listimages) : [];
                    if (this.item.images && this.item.images.length > 4) {
                        this.list.cached = [this.item.images].concat(listimages);
                    } else {
                        this.item.images = (listimages.length > 0) ? listimages[0] : 0;
                        this.list.cached = listimages;
                    }
                    this.list.data = this.list.cached.slice(0, this.list.limit);
                    this.cart = {
                        'id': this.item.id,
                        'path': this.parent_link + '/' + this.link,
                        'name': this.item.name,
                        'images': this.globals.BASE_API_URL + 'public/products/' + this.item.images,
                        'price': (this.item.price_sale && +this.item.price_sale != 0) ? this.item.price_sale : this.item.price_buy,
                        amount: 1
                    }
                    break;
                case "productcatalogry":
                    this.data = res.data;
                    break;
                default:
                    break;
            }
        });
    }

    ngOnInit() {
        setTimeout(() => {
            if (window["slides"]) {
                window["slides"]();
                
            }
            if (window["twentytwenty"]) {
                window["twentytwenty"]();
            }
        }, 100);

        this.route.params.subscribe(params => {
            this.parent_link = params.parent_link;
            this.globals.send({ path: this.token.productcatalogry, token: "productcatalogry", params: { link: this.parent_link, limit: 4 } });
            this.link = params.link;
            this.globals.send({ path: this.token.getProductDetail, token: "getProductDetail", params: { link: this.link } });

        })
        //update views products
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                let route: string = event.url;
                let t: string = '/san-pham/' + this.parent_link + '/' + this.link
                let control = (route === t) ? true : false;
                if (control) {
                    this.globals.send({ path: this.token.updateViews, token: "updateViews", params: { link: this.link } });
                };
            }
        })


    }
    // openModal(template: TemplateRef<any>) {
    //     this.modalRef = this.modalService.show(template, { class: 'modalImages' });
    // }
    isActive(images, index) {
        this.item.images = images;
        this.list.active = index;
    }
    addcart() {
        let data = this.apiCart.reduce();
        if (data[this.cart.id]) {
            let a = isNaN(+data[this.cart.id].amount) ? 1 : +data[this.cart.id].amount;
            this.cart.amount = +a + this.amount;
        }
        this.apiCart.edit(this.cart, this.cart.id)
    }
}



// WEBPACK FOOTER //
// ./src/app/frontend/detailproduct/detailproduct.component.ts